(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxNetworkComputers(
    WorkstationListService, WorkstationListPaging, $timeout, $location, $window
  ) {
    return {
      restrict: 'EA',
      scope: {
        network: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/networkComputers/networkComputers.template.html',
      link: function(scope) {

        scope.paginationObject = new WorkstationListPaging();
        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';

        (function() {
          getFirstPage();
        })();

        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 10;
          scope.paginationObject.pagingCriteria.networks = scope.network._links.self.href;
          scope.list = [];
          scope.loadingPage = true;
          WorkstationListService.getWorkstationListPaged(scope.paginationObject).then(function(workstations) {
            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = workstations.page.totalPages;
            if (workstations.list) {
              scope.list = workstations.list;
            }
          }).catch(function(error){});
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getFirstPage();
          }, 500)
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            WorkstationListService.getWorkstationListPaged(scope.paginationObject).then(function(workstations){
              if (workstations.list) {
                scope.list = scope.list.concat(workstations.list);
              }
              scope.loadingPage = false;
            }).catch(function(error){});
          }
        }

        angular.element('.ws-list-nested').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.ws-list-nested').off('scroll');
        });

        scope.gotoProperties = function (workstation) {
          var target = $location.absUrl();
          target = target.split('sites/');
          $window.open(target[0] + 'computerProperties/' + workstation.customProperties.id, '_blank');
        }

      }
    };
  }

  pxNetworkComputers.$inject = ['WorkstationListService', 'WorkstationListPaging', '$timeout', '$location', '$window'];

  angular
    .module('printix-admin')
    .directive('pxNetworkComputers', pxNetworkComputers);

})();
